export const StudentFlags: Array<string> = [
  'student_age',
  'relation_to_student',
  'enrolled_in_lea',
  'enrolled_in_soep',
  'received_another_scholarship',
  'student_age_sep',
  'student_age_affidavit',
  'student_age_special_education',
  'student_external_renewal_ineligible_declaration',
]

export const flagDocuments: Record<string, string[]> = {
  identity: [
    'ID_CARD',
    'DRIVERS_LICENSE',
    'PASSPORT',
    'PAPER_PASSPORT',
    'TEMPORARY_VISA',
  ],
  residency: ['RESIDENCY_PERMIT_CARD'],
  student_age: ['BIRTH_CERTIFICATE'],
  relation_to_student: ['BIRTH_CERTIFICATE', 'OTHER', 'RELATIONSHIP'],
  enrolled_in_lea: ['OTHER'],
  enrolled_in_soep: ['OTHER'],
  received_another_scholarship: ['OTHER'],
  student_age_sep: ['BIRTH_CERTIFICATE'],
  student_age_affidavit: ['BIRTH_CERTIFICATE'],
  tax_commission_skipped_by_applicant: [
    'TAX_INCOME_1040',
    'TAX_INCOME_W2',
    'TAX_INCOME_1099',
  ],
  tax_commission_error: ['TAX_INCOME_1040', 'TAX_INCOME_W2', 'TAX_INCOME_1099'],
  tax_commission_applicant_attested_incorrect_data: [
    'TAX_INCOME_1040',
    'TAX_INCOME_W2',
    'TAX_INCOME_1099',
  ],
  tax_commission_returned_data_does_not_match: [
    'TAX_INCOME_1040',
    'TAX_INCOME_W2',
    'TAX_INCOME_1099',
  ],
  clearme_data_inaccurate: ['ID_CARD'],
  student_age_special_education: ['SPECIAL_EDUCATION'],
  student_external_renewal_ineligible_declaration: [
    'OTHER',
    'BIRTH_CERTIFICATE',
  ],
  review_income_documents: [
    'TAX_INCOME_1040',
    'TAX_INCOME_W2',
    'TAX_INCOME_1099',
    'NON_TAXABLE_INCOME',
    'SOCIAL_SECURITY_AWARD_LETTER',
  ],
}
